import React from 'react';

import { timelineBarStyles } from '@/components/route-segment-panel/segment-schedules/timeline-bar';
import { Tooltip } from '@/components/tooltip';
import { DATETIME_FORMAT } from '@/lib/constants';
import { RouteLocationInterface } from '@/types';
import { formatToLocationDateTime } from '@/utils/format';
import { getPreferredIdentifier } from '@/utils/helpers';
import { cn } from '@/utils/styles';

interface TimeMarkerProps {
  position: number;
  date: Date;
  origin: RouteLocationInterface;
  destination: RouteLocationInterface;
  isOriginMarker?: boolean;
}

const getDateString = (date: Date, location: RouteLocationInterface, format: string): string => {
  return `${formatToLocationDateTime(date, location.timezoneName, format)}: ${
    getPreferredIdentifier(location.identifiers)?.value
  }`;
};

const getLabel = (
  date: Date,
  origin: RouteLocationInterface,
  destination: RouteLocationInterface,
  isOriginMarker: boolean,
) => {
  const originString = getDateString(date, origin, DATETIME_FORMAT);
  const destinationString = getDateString(date, destination, DATETIME_FORMAT);

  return (
    <div className="p-1">
      <p className="m-0">{isOriginMarker ? 'Earliest departure' : 'Latest arrival'}</p>
      <p className="m-0">{isOriginMarker ? originString : destinationString}</p>
      <p className="m-0">{isOriginMarker ? destinationString : originString}</p>
    </div>
  );
};

export const TimeMarker = ({ position, date, origin, destination, isOriginMarker = true }: TimeMarkerProps) => {
  const { bar } = timelineBarStyles();
  return (
    <Tooltip content={getLabel(date, origin, destination, isOriginMarker)} followCursor="vertical">
      <div
        className="pointer-events-auto absolute top-16 h-[calc(100%-4rem)] -translate-x-4 px-4"
        style={{ left: `${position}%` }}
      >
        <div className={cn(bar(), 'relative border-solid border-errorLight')}>
          <div className="absolute -left-[0.5px] -top-px right-0 -translate-x-1/2 border-x-4 border-t-4 border-x-transparent border-t-errorLight" />
        </div>
      </div>
    </Tooltip>
  );
};
